import { loadLegalDocumentActions } from '@/redux/actions/service-directory/legal-document';
import { LegalDocumentType } from '@/types';
import axios from 'axios';
import { ActionType } from 'deox';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import env, { SiteId } from '@/env';

const webAppData = {
  [SiteId.Obd]: {
    [LegalDocumentType.TERMS_OF_USE]:
      'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/OBD_TermsOfUse.html',
    [LegalDocumentType.ABOUT_US]: 'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/OBD_AboutUs.html',
    [LegalDocumentType.PRIVACY_POLICY]:
      'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/OBD_PrivacyPolicy.html',
    [LegalDocumentType.FAQ]: '',
  },
  [SiteId.DakkoHub]: {
    [LegalDocumentType.TERMS_OF_USE]:
      'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/DakkoHub_TermsOfUse.html',
    [LegalDocumentType.ABOUT_US]:
      'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/DakkoHub_AboutUs.html',
    [LegalDocumentType.PRIVACY_POLICY]:
      'https://d1c9i2hjt1qll5.cloudfront.net/htmls/legaldocuments/DakkoHub_PrivacyPolicy.html',
    [LegalDocumentType.FAQ]: '',
  },
};

const legalDocuments = {
  [LegalDocumentType.TERMS_OF_USE]: webAppData[env.siteId as keyof typeof webAppData][LegalDocumentType.TERMS_OF_USE],
  [LegalDocumentType.ABOUT_US]: webAppData[env.siteId as keyof typeof webAppData][LegalDocumentType.ABOUT_US],
  [LegalDocumentType.PRIVACY_POLICY]:
    webAppData[env.siteId as keyof typeof webAppData][LegalDocumentType.PRIVACY_POLICY],
  [LegalDocumentType.FAQ]: '',
};

export function* loadLegalDocumentSaga(action: ActionType<typeof loadLegalDocumentActions.request>) {
  try {
    const { legalDocumentType } = action.payload;
    const { data: html } = yield call(axios.get, legalDocuments[legalDocumentType]);

    yield put(loadLegalDocumentActions.success(legalDocumentType, html));
  } catch (err) {
    yield put(loadLegalDocumentActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(loadLegalDocumentActions.request.type, loadLegalDocumentSaga)]);
}
